'use strict';

export default function ($http, $timeout, pusher) {
  'ngInject';

  return {
    require: '^ngModel',
    link: link,
    scope: {
      query: '<',
      cache: '<',
      refetchInterval: '<',
      refetchEvents: '<',
      refetchDebounceMs: '<',
      refetchMaxDebounceMs: '<',
    },
  };

  function link(scope, element, attrs, ngModelCtrl) {
    const mappyObject = {
      loading: false,
      fetched: false,
      data: {},
      log: (data) => console.log(data),
      now: () => new Date(),
    };
    ngModelCtrl.$setViewValue(mappyObject);

    let refetchTimeout;

    scope.refetchDebounceMs = scope.refetchDebounceMs || 1000;
    scope.refetchMaxDebounceMs = scope.refetchMaxDebounceMs || 5000;

    function _query(limitTo) {
      // if (mappyObject.loading) return;
      mappyObject.loading = true;
      const data = { query: scope.query };
      if (limitTo !== undefined) {
        data.query = data.query.filter((_) => limitTo.indexOf(_.name) >= 0);
      }
      $http
        .post('/api/mappy/', data, { cache: !!scope.cache })
        .then(
          (response) => {
            mappyObject.errors = response.data.errors;
            Object.assign(mappyObject.data, response.data.result);
          },
          (error) => {
            mappyObject.errors = error.data;
          },
        )
        .finally(() => {
          mappyObject.fetched = true;
          mappyObject.loading = false;
          if (scope.refetchInterval) {
            if (refetchTimeout) $timeout.cancel(refetchTimeout);
            refetchTimeout = $timeout(_query, scope.refetchInterval);
          }
        });
    }

    mappyObject.refetch = _query;
    _query();

    const _eventRefetchState = {};

    function _getEventRefetchState(event) {
      if (!_eventRefetchState[event]) {
        _eventRefetchState[event] = {};
      }
      return _eventRefetchState[event];
    }

    function _refetchForEvent(event, queryNames) {
      console.log(`Refetching ${queryNames.join(', ')} for event ${event}`);
      const state = _getEventRefetchState(event);
      state.lastRefetchRequestTime = new Date().getTime();
      _query(queryNames);
    }

    function _handleRefetchEvent(event, queryNames) {
      const state = _getEventRefetchState(event);
      if (!state.lastRefetchRequestTime) {
        _refetchForEvent(event, queryNames);
        return;
      }
      if (state.timeout) {
        $timeout.cancel(state.timeout);
      }
      const now = new Date().getTime();
      const timeSinceLastRefetchRequest = now - state.lastRefetchRequestTime;
      if (timeSinceLastRefetchRequest >= scope.refetchMaxDebounceMs) {
        _refetchForEvent(event, queryNames);
      } else {
        state.timeout = $timeout(() => {
          _refetchForEvent(event, queryNames);
        }, scope.refetchDebounceMs);
      }
    }

    const _refetchMap = {};

    if (scope.refetchEvents) {
      for (const [queryName, channelName, event] of scope.refetchEvents) {
        if (_refetchMap[channelName] === undefined) {
          _refetchMap[channelName] = {
            channel: pusher.subscribe(channelName),
            eventMap: {},
          };
        }
        const { eventMap } = _refetchMap[channelName];
        if (eventMap[event] === undefined) {
          eventMap[event] = [];
        }
        eventMap[event].push(queryName);
      }
      for (const { channel, eventMap } of Object.values(_refetchMap)) {
        for (const [event, queryNames] of Object.entries(eventMap)) {
          channel.$bind(event, () => {
            _handleRefetchEvent(event, queryNames);
          });
        }
      }
    }

    scope.$on('$destroy', () => {
      console.log('Mappy scope destroyed, cleaning up...');
      if (refetchTimeout) {
        $timeout.cancel(refetchTimeout);
      }
      for (const { channel } of Object.values(_refetchMap)) {
        channel.unbind();
      }
    });
  }
}
